import api, { APIURL, errorHandle, authenHeader } from '../api/api'
import { dateTHHMS } from '../utils/dateUtils'

class Queue {
    constructor(obj) {
        this.address = obj.address
        this.first_name = obj.first_name
        this.id = obj.id
        this.last_name = obj.last_name
        this.level_id = obj.level_id
        this.office_name = obj.office_name
        this.order = obj.order
        this.position_name = obj.position_name
        this.queue_status_id = obj.queue_status_id
        this.residence_id = obj.residence_id
        this.residence_name = obj.residence_name || obj.Residence?.name
        this.residence_short_name = obj.Residence?.short_name
        this.submit_date = obj.submit_date
        this.submit_time = obj.submit_time
        this.form_submit_date = obj.form_submit_date
        this.online = obj.online
        this.tel = obj.tel
        this.email = obj.email
        this.notify_date = obj.notify_date
        this.notify_to_email = obj.notify_to_email
        this.appointment_date = obj.appointment_date
        this.appointment_location = obj.appointment_location
        this.notify_user_name = obj.notify_user_name
        this.updated_at = obj.updated_at
        this.contact_date = obj.contact_date
        this.contact_no = obj.contact_no
    }

    export() {
        return {
            "ลำดับ": this.order,
            "ชื่อ": this.first_name,
            "นามสกุล": this.last_name,
            "ตำแหน่ง": this.position_name,
            "สังกัด": this.office_name,
            "วันที่ยื่น": this.submit_date,
            "เวลา": this.submit_time,
            "ที่อยู่": this.address,
            "สถานะ": this.queue_status_id,
            "ยื่นออนไลน์": this.online ? 'Y' : 'N'
        }
    }
}

class QueueUpdateForm {
    constructor(obj) {
        this.update_name = obj.update_name
        this.update_lastname = obj.update_lastname
        this.tel = obj.tel
        this.email = obj.email
    }
}

class QueueUpdateStatus {
    /*
         appointment_date: null
         appointment_location: ""
         contract_age: "2"
         contract_date: Fri Jun 24 2022 21:30:59 GMT+0700 (Indochina Time) {}
         contract_end_date: Fri Jun 24 2022 00:00:00 GMT+0700 (Indochina Time) {}
         contract_no: "u"
         contract_start_date: Fri Jun 24 2022 00:00:00 GMT+0700 (Indochina Time) {}
         email_temp: null
         queue_status:
         label: "สมบูรณ์"
         value: "3"
         [[Prototype]]: Object
         room_no: "uu"
     */
    constructor(obj) {
        // console.log(obj)
        this.queue_status_id = obj.queue_status ? parseInt(obj.queue_status?.value) : 0
        this.email_temp_id = obj.email_temp ? parseInt(obj.email_temp?.value) : 0
        this.appointment_date = obj.appointment_date ? dateTHHMS(obj.appointment_date, true) : ""
        this.appointment_location = obj.appointment_location

        this.contract_age = parseInt(obj.contract_age)
        this.contract_date = obj.contract_date ? new Date(obj.contract_date).toISOString() : ""
        this.contract_start_date = obj.contract_start_date ? new Date(obj.contract_start_date).toISOString() : ""
        this.contract_end_date = obj.contract_end_date ? new Date(obj.contract_end_date).toISOString() : ""
        this.contract_no = obj.contract_no
        this.room_no = obj.room_no
    }
}

export { QueueUpdateForm, QueueUpdateStatus }

export const getAllQueues = (query) => {
    return new Promise((resolve, reject) => {
        api.get(APIURL.QUEUE_RESIDENCE(query))
            .then(response => {
                if (response.data.data) {
                    const list = response.data.data?.map(obj => {
                        return new Queue(obj)
                    })
                    resolve(list)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const findQueueByFullName = (query) => {
    return new Promise((resolve, reject) => {
        api.get(APIURL.QUEUE_FULLNAME(query))
            .then(response => {
                if (response.data.data) {
                    const list = response.data.data?.map(obj => {
                        return new Queue(obj)
                    })
                    resolve(list)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const getAllQueuesByName = (query, token) => {
    const headers = {
        headers: authenHeader(token)
    }
    return new Promise((resolve, reject) => {
        api.get(APIURL.QUEUE_NAME(query), headers)
            .then(response => {
                if (response.data.data) {
                    const list = response.data.data?.map(obj => {
                        return new Queue(obj)
                    })
                    resolve(list)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const getAllOwnerQueues = (uid, token) => {
    const headers = {
        headers: authenHeader(token)
    }
    return new Promise((resolve, reject) => {
        api.get(APIURL.QUEUE_OWNER(uid), headers)
            .then(response => {
                if (response.data.data) {
                    const list = response.data.data?.map(obj => {
                        return new Queue(obj)
                    })
                    // console.log('queue')
                    // console.log(list)
                    resolve(list)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const getQueue = (qid, token) => {
    const headers = {
        headers: authenHeader(token)
    }
    return new Promise((resolve, reject) => {
        api.get(APIURL.QUEUE(qid), headers)
            .then(response => {
                if (response.data.data) {
                    const obj = new Queue(response.data.data)
                    // console.log(obj)
                    resolve(obj)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}


export const patchUpdateQueueStatus = (qid, status, body, token) => {
    const param = `${qid}/${status}`
    const headers = {
        headers: authenHeader(token)
    }
    return new Promise((resolve, reject) => {
        api.patch(APIURL.QUEUE(param), body, headers)
            .then(response => {
                if (response.data.data) {
                    const obj = new Queue(response.data.data)
                    // console.log(obj)
                    resolve(obj)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const patchUpdateDisclaimQueue = (qid, token) => {
    const param = `${qid}`
    const headers = {
        headers: authenHeader(token)
    }
    return new Promise((resolve, reject) => {
        api.patch(APIURL.QUEUE_DISCLIAM(param), {}, headers)
            .then(response => {
                if (response.data.data) {
                    const obj = new Queue(response.data.data)
                    // console.log(obj)
                    resolve(obj)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const patchUpdateQueueContact = (qid, body) => {
    const param = `/${qid}`
    // body example
    // const body = {
    //     tel: tel,
    //     email: email
    // }

    return new Promise((resolve, reject) => {
        api.patch(APIURL.QUEUE_FULLNAME(param), body)
            .then(response => {
                if (response.data.data) {
                    const obj = new Queue(response.data.data)
                    // console.log(obj)
                    resolve(obj)
                } else {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

// export const postSendQueueEmailNotify = (data, token) => {

//     const headers = {
//         headers: authenHeader(token)
//     }
//     return new Promise((resolve, reject) => {
//         // console.log("postSendQueueEmailNotify")
//         // console.log(data)
//         api.post(APIURL.QUEUE('notify'), data, headers)
//             .then(response => {
//                 if (response.data.data) {
//                     // const obj = new Queue(response.data.data)
//                     // // console.log(obj)
//                     resolve(response.data.data)
//                 } else {
//                     resolve(response.data)
//                 }
//             })
//             .catch(error => {
//                 reject(errorHandle(error))
//             })
//     })
// }

export default Queue